<wl-content-section [id]="id()" [theme]="theme()" [hasContext]="!!context()">
  @if (showLoader()) {
    <wl-loading-screen
      [title]="loadingScreenTitle"
      [subtitle]="address()"
      [items]="loaderItems"
      [duration]="loadingDuration"
      (finished)="showLoader.set(false)"
      wlAutomationId="homebattery-order-form-loading-screen"
    />
  }
  <wl-solar-panels-result-overview-ui
    [rendering]="rendering()"
    [address]="address()"
    [building]="viewModel().building"
    [product]="viewModel().product"
    (submitted)="onSubmit()"
    (openPropositionModal)="onOpenPropositionMoreInfoModal($event)"
  ></wl-solar-panels-result-overview-ui>
</wl-content-section>
